import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import KendoDataSourceBase from '../KendoDataSourceBase'
import GanttDependencyDataSourceProps from './GanttDependencyDataSourceProps'

import Schema from './Schema'
import Filter from '../KendoDataSourceBase/Filter'
import Group from '../KendoDataSourceBase/Group'
import Sort from '../KendoDataSourceBase/Sort'
import Transport from '../KendoDataSourceBase/Transport'

export default {
    props: GanttDependencyDataSourceProps,
    mixins: [
        KendoBaseComponent,
        KendoDataSourceBase, 
        Filter,
        Group,
        Schema,
        Sort,
        Transport
    ],
    mounted() {
        this.kendoDataSource = new kendo.data.GanttDependencyDataSource(this.widgetOptions)
    },
    methods: {
        kendoWidget() {
            return this.kendoDataSource || new kendo.data.GanttDependencyDataSource(this.widgetOptions)
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoGanttDependencyDataSource/KendoGanttDependencyDataSourceMixin.js